import { memo } from 'react'

const MeetingScheduledIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="128"
      height="107"
      fill="none"
      viewBox="0 0 128 107"
    >
      <g clipPath="url(#clip0_2269_17461)">
        <path
          fill="#EAEEF9"
          d="M122.848 55.798c0 14.2-5.8 27-15.1 36.2-9.1 9.1-21.7 14.6-35.6 14.6-13.8 0-26.4-5.6-35.6-14.6-9.3-9.2-15.1-22-15.1-36.2 0-28.1 22.7-50.8 50.7-50.8s50.7 22.8 50.7 50.8M118.449 22.499a4.1 4.1 0 1 0 0-8.201 4.1 4.1 0 0 0 0 8.2M124.449 6.498a2.8 2.8 0 0 0 2.8-2.8 2.795 2.795 0 0 0-1.728-2.586 2.802 2.802 0 0 0-3.872 2.586 2.799 2.799 0 0 0 2.8 2.8M23.049 22.399a2.8 2.8 0 1 0 0-5.6 2.8 2.8 0 0 0 0 5.6M5.949 76.398a5.2 5.2 0 1 0 0-10.4 5.2 5.2 0 0 0 0 10.4"
        ></path>
        <path
          fill="#fff"
          d="M107.749 29.198v62.8c-9.1 9.1-21.7 14.6-35.6 14.6-13.8 0-26.4-5.6-35.6-14.6v-62.8z"
        ></path>
        <path
          fill="#8E33FF"
          d="m73.406 61.252-13.93-13.93-4.737 4.737 13.93 13.93z"
          opacity="0.5"
        ></path>
        <path
          fill="#8E33FF"
          d="M84.832 40.398 64.043 61.185l4.738 4.739 20.788-20.79z"
          opacity="0.5"
        ></path>
        <path
          fill="#D5DAE5"
          d="M90.35 74.498h-36.4v4.6h36.4zM90.35 84.599h-36.4v4.6h36.4zM81.449 94.799h-18.6v4.6h18.6z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2269_17461">
          <path fill="#fff" d="M0 0h128v107H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
}

export default memo(MeetingScheduledIcon);
